/**
 * Writes the provided rich and plain text to the clipboard.
 * @param {{ rich: string, plain: string }} param0 - The text to copy.
 *
 * @returns {Promise<ClipboardItem>} - A promise that resolves with the ClipboardItem.
 */
export const writeToClipboard = async ({ rich, plain }) =>
  new Promise(async (resolve, reject) => {
    try {
      const clipboardData = {};

      if (rich) {
        const html = new Blob([rich], { type: "text/html" });
        clipboardData["text/html"] = html;
      }

      if (plain) {
        const textBlob = new Blob([plain], { type: "text/plain" });
        clipboardData["text/plain"] = textBlob;
      }

      const data = new ClipboardItem(clipboardData);

      await navigator.clipboard.write([data]);
      resolve(data);
      console.log("Text copied to clipboard");
    } catch (error) {
      console.error("Failed to copy text to clipboard", error);
      reject(error);
    }
  });
